import {GET_ALL_REQUESTS} from "../../../enums/Request/request.types";

export const getAllUserRequestsAction = (data) => {
    return {
        type: GET_ALL_REQUESTS,
        payload: data,
    };
};
